module.exports = __webpack_public_path__ + "img/money-bag.62e991c8.svg";